import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDataPoints = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#646060",
			d: "M4.16665 13.3333C4.16665 14.2538 3.42045 15 2.49998 15C1.5795 15 0.833313 14.2538 0.833313 13.3333C0.833313 12.4129 1.5795 11.6667 2.49998 11.6667C3.42045 11.6667 4.16665 12.4129 4.16665 13.3333Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#646060",
			d: "M9.99998 7.5C9.99998 8.42047 9.25379 9.16667 8.33331 9.16667C7.41284 9.16667 6.66665 8.42047 6.66665 7.5C6.66665 6.57953 7.41284 5.83333 8.33331 5.83333C9.25379 5.83333 9.99998 6.57953 9.99998 7.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#646060",
			d: "M14.1666 11.6667C14.1666 12.5871 13.4205 13.3333 12.5 13.3333C11.5795 13.3333 10.8333 12.5871 10.8333 11.6667C10.8333 10.7462 11.5795 10 12.5 10C13.4205 10 14.1666 10.7462 14.1666 11.6667Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#646060",
			d: "M19.1666 6.66667C19.1666 7.58714 18.4205 8.33333 17.5 8.33333C16.5795 8.33333 15.8333 7.58714 15.8333 6.66667C15.8333 5.74619 16.5795 5 17.5 5C18.4205 5 19.1666 5.74619 19.1666 6.66667Z"
		})
	]
});
export default SvgDataPoints;
